import React, { useContext, useState, useEffect, useCallback } from 'react'
import LocationFloristUI from '@interflora/ui-components/build/components/LocationFlorist/LocationFlorist'
import { removeSessionItems, SiteContext } from '@interflora/ui-components/build/utils/common'
import algoliasearch from 'algoliasearch'
import { FLORIST_GEO_SEARCH_RADIUS_METERS } from '../../constants'
import { useLoaded } from '@interflora/ui-components'

const envPrefix = process.env.NEXT_PUBLIC_ALGOLIA_ENV_PREFIX
const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY
)

type Props = {
  latitude: string
  longitude: string
  location: string
}

const LocationFlorist = (props: Props) => {
  const { latitude, longitude, location } = props
  const { shorthand } = useContext(SiteContext)
  const [pageNo, setPageNo] = useState(0)
  const [florists, setFlorists] = useState([])
  const HITS_PER_PAGE = 3
  const [hasMore, setHasMore] = useState(false)
  const index = searchClient.initIndex(`${envPrefix}_florist_${shorthand}`)

  const algoliaSearch = useCallback(
    async (pageNo: number) => {
      if (!latitude || !longitude) {
        return []
      }
      const algoliaSearchResults = await index.search('', {
        aroundLatLng: `${latitude}, ${longitude}`,
        aroundRadius: FLORIST_GEO_SEARCH_RADIUS_METERS,
        hitsPerPage: HITS_PER_PAGE,
        page: pageNo,
        distinct: true,
      })
      const { hitsPerPage, hits, nbHits, page } = algoliaSearchResults
      const floristDetails = hits?.map((hit: any) => hit?.data)
      const totalViewed = hits.length === hitsPerPage ? (page + 1) * hitsPerPage : nbHits
      setHasMore(totalViewed < nbHits)
      return floristDetails
    },
    [index, latitude, longitude]
  )

  const onLoadMore = async () => {
    const newPageNo = pageNo + 1
    setPageNo(newPageNo)
    const floristsResults = await algoliaSearch(newPageNo)
    setFlorists(florists.concat(floristsResults))
  }
  useEffect(() => {
    ;(async () => {
      const floristResults = await algoliaSearch(0)
      setFlorists(floristResults)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  useEffect(() => {
    removeSessionItems(['isFromPLP', 'breadcrumb'])
  })

  useLoaded(props)

  return <LocationFloristUI location={location} onLoadMore={onLoadMore} localFlorists={florists} hasMore={hasMore} />
}
export default LocationFlorist
